const lockArticle = document.getElementById("klaviyo_lock");
if (lockArticle) {
  const checkCookie = (name) => {
    return document.cookie
      .split(";")
      .some((item) => item.trim().startsWith(name + "="));
  };

  const createCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + (value || "") + expires + "; path=/; secure; samesite=Lax";
  };

  const fadeOutAndRemove = (target) => {
    target.classList.add("klaviyo-hidden");
    target.addEventListener("transitionend", function handler() {
      target.removeEventListener("transitionend", handler);
      target.style.display = "none";
      target.remove();
    });
  };

  const handleFormBtn = (klaviyoFormBtn) => {
    if (checkCookie("klaviyo-article-email")) {
      fadeOutAndRemove(lockArticle);
      return;
    }

    document
      .querySelector(
        `.template-article.article-locked #klaviyo_lock .klaviyo-container .klaviyo_lock_article .hidden`
      )
      ?.classList.remove("hidden");

    const formArticleSubmit = () => {
      setTimeout(() => {
        const klaviyoFormBtnCheck = document.querySelector(
          `.template-article.article-locked #klaviyo_lock form button[type="button"]`
        );
        if (!klaviyoFormBtnCheck) {
          createCookie("klaviyo-article-email", "true", 30);
          fadeOutAndRemove(lockArticle);
        }
      }, 5000);
    };

    klaviyoFormBtn.addEventListener("click", formArticleSubmit, false);
  };

  const observer = new MutationObserver(() => {
    const klaviyoFormBtn = document.querySelector(
      `.template-article.article-locked #klaviyo_lock form button[type="button"]`
    );
    if (klaviyoFormBtn) {
      observer.disconnect();
      handleFormBtn(klaviyoFormBtn);
    }
  });

  observer.observe(lockArticle, {
    childList: true,
    subtree: true,
  });
}